import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { CONTACT } from '../../data/navigation';
interface HeroContactPanelProps {
  /** Distinguishes the desktop and stacked instances for label ids. */
  idSuffix: string;
  className?: string;
}
export function HeroContactPanel({
  idSuffix,
  className = ''
}: HeroContactPanelProps) {
  const headingId = `hero-help-heading-${idSuffix}`;
  return <aside aria-labelledby={headingId} className={`w-full border border-white/12 border-t-2 border-t-copper bg-navy/95 p-6 sm:p-7 ${className}`} data-id="element-182" data-mp="1wzj69z6xlhnb">
      <p className="flex items-center gap-3 font-mono text-[9.5px] tracking-label text-copper" data-id="element-183" data-mp="26xqi63md59ig">
        <span aria-hidden="true" className="h-px w-5 bg-copper" data-id="element-184" data-mp="21y45pweczxap" />
        APPLICATION HELP
      </p>
      <h2 id={headingId} className="mt-3 font-display text-[19px] font-medium leading-snug text-white" data-id="element-185" data-mp="3ibubr8p1gvmz">
        Talk through your setup
      </h2>

      <address className="mt-6 block not-italic" data-id="element-186" data-mp="qj3pnfm2p88h">
        <dl className="grid grid-cols-2 gap-x-6 gap-y-4 border-t border-white/10 pt-4" data-id="element-187" data-mp="qibw0ac1dkku">
          <div data-id="element-188" data-mp="vh54tpgdoneo">
            <dt className="font-mono text-[9.5px] tracking-label text-aluminum/70" data-id="element-189" data-mp="vgn3ieeuzizw">
              SALES
            </dt>
            <dd className="mt-1.5" data-id="element-190" data-mp="10f6u4s4ediyl">
              <a href={CONTACT.phoneHref} data-analytics="phone-click" data-analytics-line="sales" data-analytics-location="hero-panel" className="inline-flex min-h-[28px] items-center whitespace-nowrap font-mono text-[15px] text-white underline decoration-copper decoration-1 underline-offset-4 transition-colors duration-150 ease-precise hover:text-cta" data-id="element-191" data-mp="14jegwjraoou6">
                {CONTACT.phoneLabel}
              </a>
            </dd>
          </div>
          <div data-id="element-192" data-mp="3l70fzvyaqjvs">
            <dt className="font-mono text-[9.5px] tracking-label text-aluminum/70" data-id="element-193" data-mp="3l5flu7fw92yg">
              TECHNICAL
            </dt>
            <dd className="mt-1.5" data-id="element-194" data-mp="wedfm52q1mjy">
              <a href={CONTACT.techPhoneHref} data-analytics="phone-click" data-analytics-line="technical" data-analytics-location="hero-panel" className="inline-flex min-h-[28px] items-center whitespace-nowrap font-mono text-[15px] text-white underline decoration-copper decoration-1 underline-offset-4 transition-colors duration-150 ease-precise hover:text-cta" data-id="element-195" data-mp="wdllyzsopywb">
                {CONTACT.techPhoneLabel}
              </a>
            </dd>
          </div>
          <div className="col-span-2 min-w-0" data-id="element-196" data-mp="8j0vbu03sjqe">
            <dt className="font-mono text-[9.5px] tracking-label text-aluminum/70" data-id="element-197" data-mp="mhildydhe8bh">
              EMAIL
            </dt>
            <dd className="mt-1.5" data-id="element-198" data-mp="idkidcl1cdd5">
              <a href={CONTACT.emailHref} data-analytics="email-click" data-analytics-location="hero-panel" className="inline-flex min-h-[28px] max-w-full items-center whitespace-nowrap text-[14.5px] text-white underline decoration-copper decoration-1 underline-offset-4 transition-colors duration-150 ease-precise hover:text-cta" data-id="element-199" data-mp="1xvmdt04f7oef">
                sales@sheargeometry.com
              </a>
            </dd>
          </div>
          <div className="col-span-2" data-id="element-200" data-mp="1wegtp6pt71ow">
            <dt className="font-mono text-[9.5px] tracking-label text-aluminum/70" data-id="element-201" data-mp="1wf8hhvd5zv4m">
              MAILING ADDRESS
            </dt>
            <dd className="mt-1.5 max-w-[30ch] text-[13.5px] leading-relaxed text-aluminum" data-id="element-202" data-mp="2k64gpdjy9slw">
              {CONTACT.mailingAddress}
            </dd>
          </div>
        </dl>
      </address>

      <Link to="/#product-guidance" data-analytics="product-guidance-cta" data-analytics-location="hero-panel" className="mt-6 inline-flex min-h-[44px] items-center gap-2 border-b border-copper text-[14px] font-semibold text-white transition-colors duration-150 ease-precise hover:text-cta" data-id="element-203" data-mp="2adyfrebq00uk">
        Tell Us What You’re Cutting
        <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-204" data-mp="1k6c0ypslmeh5" />
      </Link>
    </aside>;
}